import GriAdminUsers from "./users";
import GriAdminCollects from "./collects";
import SRToolBaseChartPage from "./dashboard/gri-admin-dashboard";

export const GriAdminUsersPage = GriAdminUsers;
export const GriAdminCollectsPage = GriAdminCollects;
// export default const SRToolBaseChartPage = SRToolBaseChartPage;

